import React from 'react';

import {
  BookDemoSection,
  GetStarted,
  HeadingTitle,
  Strong,
  DemoDetails,
  ButtonWrapper,
  DefaultButton,
  CallusButton,
} from './styled';

const BookDemo = () => {
  return (
    <BookDemoSection>
      <GetStarted>
        <HeadingTitle>
          Get Started <span className='hideonMobile'>With</span> 
          <Strong className='hideonMobile'>E-Retail Point</Strong>
        </HeadingTitle>
        <DemoDetails className='hideonMobile'>
          Book now for a free, no-commitment demo! And don't be concerned about the obstacles in your business.
        </DemoDetails>
        <ButtonWrapper className='hidden'>
          <DefaultButton>Book Free Demo</DefaultButton>
          <CallusButton>Call Us Now</CallusButton>
        </ButtonWrapper>
      </GetStarted>
    </BookDemoSection>
  )
}

export default BookDemo;